module.exports = __webpack_public_path__ + "media/images/flags/32/Uzbekistan-9ea26975affd4b14ae1ade466cf02b95.png";